import FormInput from '../../../../../components/Form/FormInput';
import moment from 'moment';
import { usePersonalAfectado } from '../../../../../hooks/usePersonalAfectado';
import { useDocumentoPersAfectado } from '../../../../../hooks/useDocumentoPersAfectado';
import Table, {
  ColumnDefinitionType,
} from '../../../../../components/Table';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import MyModal from '../../../../../components/Modal';
import { DocumentoPersPropio } from '../../../../../types/DocumentoPersPropio';
import { useDocumento } from '../../../../../hooks/useDocumento';
import { Historial } from '../../DocumentosAdjuntos/historial';
import {
  downloadAndOpenFile,
  downloadFile,
} from '../../../../../services/Service';
import { Button } from 'react-bootstrap';
import { OBSERVADA_STATUS_ID } from '../../../../../constants/constants';
import { useUserLogin } from '../../../../../hooks/useUserLogin';
import { useSolicitud } from '../../../../../hooks/useSolicitud';
import ObservacionComponent from '../../../../../components/Observaciones';

interface DetailPersonalPropioProps {
  onClose: () => void;
}

const DetailPersonalPropio: React.FC<DetailPersonalPropioProps> = ({
  onClose,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIdTipoDocumento, setSelectedIdTipoDocumento] =
    useState<number>(0); // Estado para mantener el ID seleccionado
  const toggle = () => setIsOpen(!isOpen);
  const { personalPropioSelected } = usePersonalAfectado();
  const {
    documentoPersonalPropioList,
    handleDocumentoPersPropioSelected,
    documentoPersonalPropioSelected,
  } = useDocumentoPersAfectado();
  const {
    historialDocumentos,
    buscarDocumentosByIdTipoDocumento,
    handleDocumentoSelected,
    documentoInitial,
  } = useDocumento();
  const handleDocumento = async (id: number) => {
    setSelectedIdTipoDocumento(id);
    toggle();
  };
  const [
    isOpenModalObservacionDocument,
    setIsOpenModalObservacionDocument,
  ] = useState(false);
  const { isContratistaTipoUsuario } = useUserLogin();
  const { solicitudSelected } = useSolicitud();
  const getDocumentoSelected = (id: number) => {
    if (id) {
      const doc =
        historialDocumentos.find((d) => d.idTipoDocumento === id) ||
        documentoInitial;
      handleDocumentoSelected(doc);
      toggle();
      setSelectedIdTipoDocumento(0);
    }
  };

  useEffect(() => {
    // Dependiendo de cómo se use historialDocumentos, podrías necesitar un efecto para manejar su actualización
    // Realiza las acciones que necesites con el historialDocumentos actualizado aquí
    //getDocumentoSelected(selectedIdTipoDocumento);
  }, [historialDocumentos]);
  const columns: ColumnDefinitionType<
    DocumentoPersPropio,
    keyof DocumentoPersPropio
  >[] = [];
  columns.push({
    key: 'tipoDocumento',
    header: 'TIpo Documento',
  });
  columns.push({
    key: 'nombreArchivo',
    header: 'Nombre',
  });
  columns.push({
    key: 'fechaVencimiento',
    header: 'Fecha Vencimiento',
    cell: (data: DocumentoPersPropio) => {
      const isExpired =
        data.fechaVencimiento &&
        moment(data.fechaVencimiento).isBefore(moment(), 'day');
      return (
        <span style={{ color: isExpired ? 'red' : 'inherit' }}>
          {data.fechaVencimiento
            ? moment(data.fechaVencimiento).format('DD/MM/YYYY')
            : ''}
        </span>
      );
    },
  });
  columns.push({
    key: 'idUsuarioRevisor',
    header: 'Revisor',
    cell: (data: DocumentoPersPropio) => (
      <>
        {data.nombreUsuarioRevisor && data.apellidoUsuarioRevisor
          ? `${data.apellidoUsuarioRevisor}, ${data.nombreUsuarioRevisor}`
          : ''}
      </>
    ),
  });
  if (
    isContratistaTipoUsuario() &&
    solicitudSelected.idTipoEstado === OBSERVADA_STATUS_ID
  ) {
    columns.push({
      key: 'observacion',
      header: 'Observaciones',
      cell: (data: DocumentoPersPropio) => (
        <>
          {data.observacion && (
            <a
              href="#"
              title="Observaciones"
              onClick={() => {
                handleDocumentoPersPropioSelected(data);
                setIsOpenModalObservacionDocument(true);
              }}
            >
              <i
                className="fa fa-search me-2"
                style={{ color: 'red' }}
                aria-hidden="true"
              ></i>
            </a>
          )}
        </>
      ),
    });
  }

  columns.push({
    key: 'id',
    header: 'Acciones',
    cell: (data: DocumentoPersPropio) => (
      <>
        <Link
          title="Visualizar"
          to="/exportar"
          onClick={(e) => {
            e.preventDefault();
            downloadAndOpenFile(
              'documento-personal/visualizarArchivo',
              data
            );
          }}
          target="_blank"
        >
          <i
            className="fa fa-eye text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
        <Link
          title="Descargar"
          to="/exportar"
          onClick={(e) => {
            e.preventDefault();
            downloadFile('documento-personal/descargarArchivo', data);
          }}
          target="_blank"
        >
          <i
            className="fa fa-arrow-down text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
        <a
          href="#"
          title="Historial de Documentos"
          onClick={() => handleDocumento(data.idTipoDocumento)}
        >
          <i
            className="fa fa-history text-secondary "
            aria-hidden="true"
          ></i>
        </a>
      </>
    ),
  });
  columns.push({
    key: 'statusDocumento',
    header: '',
  });

  return (
    <>
      <MyModal
        isOpen={isOpenModalObservacionDocument}
        toggle={() => setIsOpenModalObservacionDocument(false)}
        title="Observaciones"
        cancelButton={false}
        secondButton={false}
      >
        <ObservacionComponent
          observacion={documentoPersonalPropioSelected.observacion}
          isEdit={false}
          cancelButtonFn={() =>
            setIsOpenModalObservacionDocument(false)
          }
          returnButtonFn={() =>
            setIsOpenModalObservacionDocument(false)
          }
        ></ObservacionComponent>
      </MyModal>
      <MyModal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        title="Historial de Documentos"
      >
        <Historial
          tipoDocumentoDisabled={true}
          pathService={`documento-personal/personal-propio/${personalPropioSelected.id}`}
          idTipoDocumentoSelected={selectedIdTipoDocumento}
        />
      </MyModal>
      <div>
        <div className="row mt-2">
          <FormInput
            id={'tipoDocumento'}
            label={'Tipo Doc Persona'}
            name={'tipoDocumento'}
            value={personalPropioSelected.tipoDocumento || ''}
            isDisabled={true}
          />
          <FormInput
            id={'nroDocumento'}
            label={'Nro. Documento'}
            name={'nroDocumento'}
            value={personalPropioSelected.nroDocumento || ''}
            isDisabled={true}
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'nombre'}
            label={'Nombre'}
            name={'nombre'}
            value={personalPropioSelected.nombre || ''}
            isDisabled={true}
          />
          <FormInput
            id={'apellido'}
            label={'Apellido'}
            name={'apellido'}
            value={personalPropioSelected.apellido || ''}
            isDisabled={true}
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'fechaIngreso'}
            label={'Fecha Ingreso Trabajo'}
            name={'fechaIngreso'}
            value={
              personalPropioSelected.fechaIngreso
                ? moment(personalPropioSelected.fechaIngreso).format(
                    'DD/MM/YYYY'
                  )
                : ''
            }
            isDisabled={true}
          />
          <FormInput
            id={'observaciones'}
            label={'Observaciones'}
            name={'observaciones'}
            value={personalPropioSelected.observaciones || ''}
            isDisabled={true}
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'actividad'}
            label={'Actividad'}
            name={'actividad'}
            value={personalPropioSelected.actividad || ''}
            isDisabled={true}
          />
        </div>
      </div>
      <div className="p-3">
        <div className="row">
          <div className="col-md-12 text-end">
            {/* <Button
                            disabled={true}
                            className="btn-secondary"
                            variant="secondary"
                        > Agregar Documentos
                        </Button> */}
          </div>
        </div>
        <div className="table-responsive ">
          <Table
            data={documentoPersonalPropioList}
            columns={columns}
          ></Table>
        </div>
      </div>
      <div className="col-md-12 d-flex justify-content-center">
        <Button color="btn-info" onClick={onClose} className="mr-2">
          Volver
        </Button>
      </div>
    </>
  );
};

export default DetailPersonalPropio;
